var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 57,
    viewBox: "0 0 53 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82641 43.7698C2.01687 45.4231 3.52612 46.61 5.18942 46.5782L17.8448 46.3326C17.8087 46.5906 17.7868 46.8525 17.7924 47.1204C17.8471 49.9036 20.1469 52.1166 22.9301 52.0619C25.7132 52.0072 27.9263 49.7074 27.8716 46.9242C27.866 46.6563 27.8339 46.3952 27.7894 46.139L40.4434 45.893C42.1067 45.8611 43.5696 44.6149 43.6952 42.9565C43.8394 41.0533 42.3194 39.484 40.4562 39.5202L39.6209 38.656C37.8274 36.7995 36.803 34.3333 36.752 31.7526L36.5909 23.4177C36.4511 16.2339 31.0018 10.4154 24.0632 9.59402C25.1808 8.89979 25.9231 7.66472 25.8967 6.25406C25.8555 4.12592 24.0967 2.43323 21.9682 2.47568C19.8401 2.51684 18.1474 4.27563 18.1898 6.40412C18.2175 7.81512 19.007 9.02036 20.1508 9.6705C13.2492 10.7609 8.02987 16.7861 8.16966 23.9698L8.33347 32.398C8.39174 35.374 7.14854 38.2262 4.93143 40.2116C3.06598 40.2458 1.60867 41.8731 1.82641 43.7698ZM24.2929 6.28529C24.3172 7.52841 23.3282 8.55657 22.0851 8.58093C20.842 8.60529 19.8138 7.61628 19.7894 6.37316C19.7651 5.13004 20.7541 4.10185 21.9972 4.07749C23.2416 4.05348 24.2688 5.04088 24.2929 6.28529Z",
    fill: "#F9BA49",
    stroke: "#59656E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5992 45.7572L20.0177 45.8667",
    stroke: "#59656E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4915 39.5173L9.89061 40.015",
    stroke: "#59656E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBell);
export default __webpack_public_path__ + "static/media/email-bell.bc8f0b80742aef944a8a290ff3bf8f89.svg";
export { ForwardRef as ReactComponent };